import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import type { StorageLocationView } from "adl-gen/ferovinum/app/api";
import type { FormikForm } from "components/types/formik-types";
import { ensure } from "utils/null-and-undefined-utils";
import type { DeliveryFormValues } from "../organisation-repurchase-delivery-page-view";

export const WarehouseDeliveryOption = ({
  form,
  storageLocation,
  internalTransferLocations,
  canSelectSiteCode,
  siteCodeIsRequired,
}: {
  form: FormikForm<DeliveryFormValues>;
  storageLocation: StorageLocationView;
  internalTransferLocations: StorageLocationView[];
  canSelectSiteCode: boolean;
  siteCodeIsRequired: boolean;
}) => (
  <Grid container direction={"column"} gap={2}>
    <Grid item xs={12} lg={6}>
      <Typography variant="caption">
        {`Please input ${canSelectSiteCode ? "the site code, and" : ""} your account code below. `}
        {!storageLocation.requiresAccountCodeForInWarehouseTransfer &&
          "If you don’t have one, you can leave this field blank."}
      </Typography>
    </Grid>
    <Grid item xs={12} lg={6}>
      <Grid container direction={"row"} gap={2}>
        {siteCodeIsRequired && (
          <Grid item xs={6} lg={3}>
            <FormControl fullWidth>
              <InputLabel id="locationId-label">Site Code</InputLabel>
              <Select
                id="siteCode"
                labelId="siteCode"
                autoFocus={false}
                name="siteCode"
                label="Site Code"
                value={form.values.siteCode}
                onChange={form.handleChange}
                required={siteCodeIsRequired}
                error={
                  (form.touched?.siteCode ?? false) &&
                  Boolean(form.errors?.siteCode ?? false)
                }
                disabled={!canSelectSiteCode}
              >
                {internalTransferLocations.map((loc) => (
                  <MenuItem value={ensure(loc.siteCode)} key={loc.siteCode}>
                    {loc.siteCode} ({loc.storageLocationName})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
        <Grid item xs={6} lg={3}>
          <TextField
            fullWidth={true}
            name="accountCode"
            label="Account code"
            error={
              (form.touched?.accountCode ?? false) &&
              Boolean(form.errors?.accountCode ?? false)
            }
            required={storageLocation.requiresAccountCodeForInWarehouseTransfer}
            value={form.values.accountCode}
            onChange={form.handleChange}
          />
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);
